import React, { useState } from 'react';
import { importarPrograma } from '../../servicios/programaService';
import { esperarBackend } from '../../servicios/api';

export default function ImportarPrograma({ onImportado, onCerrar }) {
  const [archivo, setArchivo] = useState(null);
  const [nombre, setNombre] = useState('');
  const [cargando, setCargando] = useState(false);
  const [calentando, setCalentando] = useState(false);
  const [intentoCalentamiento, setIntentoCalentamiento] = useState(0);
  const [error, setError] = useState('');
  const [resultado, setResultado] = useState(null);

  const handleArchivo = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.name.endsWith('.xml')) {
      setError('Solo se aceptan archivos .xml (exportados desde MS Project o Primavera P6)');
      return;
    }
    setError('');
    setArchivo(file);
    if (!nombre) {
      setNombre(file.name.replace('.xml', ''));
    }
  };

  const handleImportar = async () => {
    if (!archivo) {
      setError('Selecciona un archivo XML');
      return;
    }

    setCargando(true);
    setCalentando(true);
    setIntentoCalentamiento(0);
    setError('');

    const serverOk = await esperarBackend(60000, 5000, setIntentoCalentamiento);
    setCalentando(false);

    if (!serverOk) {
      setError('El servidor no respondió. El servidor en Render puede tardar hasta 60s en iniciar — espera unos segundos e intenta de nuevo.');
      setCargando(false);
      return;
    }

    try {
      const resultadoImport = await importarPrograma({
        archivo,
        nombre: nombre.trim() || archivo.name.replace('.xml', '')
      });
      if (resultadoImport?.resumenAvances) {
        setResultado(resultadoImport);
      } else {
        onImportado(resultadoImport);
      }
    } catch (err) {
      const msg = err?.response?.data?.error || err?.response?.data?.detalle || err.message || 'Error al importar';
      setError(msg);
    } finally {
      setCargando(false);
    }
  };

  if (resultado) {
    const { heredadas, nuevas } = resultado.resumenAvances;
    return (
      <div className="programa-modal-overlay" onClick={onCerrar}>
        <div className="programa-modal" onClick={e => e.stopPropagation()}>
          <h3>Programa importado</h3>
          <p style={{ fontSize: '0.85rem', color: '#334155', margin: '0 0 4px 0' }}>
            {heredadas} actividad{heredadas === 1 ? '' : 'es'} heredaron su avance registrado de la versión anterior (mismo código WBS).
          </p>
          <p style={{ fontSize: '0.85rem', color: '#334155', margin: '0 0 16px 0' }}>
            {nuevas} actividad{nuevas === 1 ? '' : 'es'} son nuevas o cambiaron de WBS y parten en 0%.
          </p>
          <div className="programa-modal-footer">
            <button className="programa-btn programa-btn-primary" onClick={() => onImportado(resultado)}>
              Listo
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="programa-modal-overlay" onClick={onCerrar}>
      <div className="programa-modal" onClick={e => e.stopPropagation()}>
        <h3>Importar programa de obra</h3>

        {error && <div className="programa-error">{error}</div>}

        <div className="programa-modal-campo">
          <label>Archivo XML (MS Project o Primavera P6)</label>
          <input
            type="file"
            accept=".xml"
            onChange={handleArchivo}
            disabled={cargando}
          />
        </div>

        <div className="programa-modal-campo">
          <label>Nombre de la versión</label>
          <input
            type="text"
            placeholder="Ej: Programa v1, Reprogramación Mayo 2026"
            value={nombre}
            onChange={e => setNombre(e.target.value)}
            disabled={cargando}
          />
        </div>

        <p style={{ fontSize: '0.8rem', color: '#94a3b8', margin: '0 0 8px 0' }}>
          Al importar, este programa quedará como la nueva línea base activa del proyecto.
          Si ya había avances registrados, se heredan automáticamente a las actividades con el mismo código WBS.
        </p>

        <div className="programa-modal-footer">
          <button className="programa-btn programa-btn-secondary" onClick={onCerrar} disabled={cargando}>
            Cancelar
          </button>
          <button
            className="programa-btn programa-btn-primary"
            onClick={handleImportar}
            disabled={cargando || !archivo}
          >
            {cargando && <span className="programa-spinner" />}
            {calentando ? `Iniciando servidor... (${intentoCalentamiento}/12)` : cargando ? 'Importando...' : 'Importar'}
          </button>
        </div>
      </div>
    </div>
  );
}

